import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { LineupPlayerComponent } from '../lineup-player/lineup-player.component';
import { Missing } from '../../models';

@Component({
  selector: 'app-lineup-players-group',
  standalone: true,
  imports: [LineupPlayerComponent],
  templateUrl: './lineup-players-group.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LineupPlayersGroupComponent {
  title = input.required<string>();
  homeLineUp = input.required<Missing[]>();
  awayLineUp = input.required<Missing[]>();
}
